import type { BirthInputDraft } from './birthInput.js';
import type { TopicId } from './rules.js';
import { DEFAULT_NATAL_TOPICS } from './interpretation.js';
import type { ApplicationWorkflowOptions, CalculationEngine } from './applicationWorkflow.js';
import { compareBirthTimeWindow, runHoroscopeWorkflow, runNatalWorkflow } from './applicationWorkflow.js';
import { productionNatalInterpretationPacks } from './productionInterpretation.js';
import { buildTopicCoverageViewModel } from './topicCoveragePresentation.js';

export async function runProductionNatalWorkflow(
  inputDraft: BirthInputDraft,
  engine: CalculationEngine,
  topics: readonly TopicId[] = DEFAULT_NATAL_TOPICS,
  options: ApplicationWorkflowOptions = {},
) {
  const packs = productionNatalInterpretationPacks();
  const result = await runNatalWorkflow(inputDraft, engine, packs.rulePack, packs.templatePack, topics, options);
  if (!result.ok) return result;
  return Object.freeze({
    ...result,
    topicCoverage: buildTopicCoverageViewModel(result.report, packs.rulePack, topics),
  });
}

export async function runProductionHoroscopeWorkflow(
  inputDraft: BirthInputDraft,
  targetDate: string,
  targetTimeIndex: number,
  engine: CalculationEngine,
  natalTopics: readonly TopicId[] = DEFAULT_NATAL_TOPICS,
  horoscopeTopics: readonly TopicId[] = ['timing'],
  options: ApplicationWorkflowOptions = {},
) {
  const packs = productionNatalInterpretationPacks();
  const result = await runHoroscopeWorkflow(
    inputDraft,
    targetDate,
    targetTimeIndex,
    engine,
    packs.rulePack,
    packs.templatePack,
    natalTopics,
    horoscopeTopics,
    options,
  );
  if (!result.ok) return result;
  return Object.freeze({
    ...result,
    topicCoverage: buildTopicCoverageViewModel(result.report, packs.rulePack, natalTopics),
  });
}

export function compareProductionBirthTimeWindow(
  inputDraft: BirthInputDraft,
  engine: CalculationEngine,
  topics: readonly TopicId[] = ['personality', 'career', 'wealth', 'relationship'],
  radius = 1,
  options: ApplicationWorkflowOptions = {},
) {
  const packs = productionNatalInterpretationPacks();
  return compareBirthTimeWindow(inputDraft, engine, packs.rulePack, packs.templatePack, topics, radius, options);
}
